import { I18nService } from 'src/app/modules/i18n/i18n.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements OnInit {
  language: any;
  selectedLang: any = '';
  isMobile = false;
  currentSelectedValue = 'English'
  constructor(
    private i18nService: I18nService,
    private translate: TranslateService,
    ) {}

  ngOnInit() {
    this.selectedLang = '';
    this.language = this.currentLanguage;
    this.currentSelectedValue = this.languages.find((langObj:any) => langObj.id == this.language ).regional;
    this.translate.onLangChange.subscribe((l: any) => {
      this.language = this.translate.currentLang;
      this.currentSelectedValue = this.languages.find((langObj:any) => langObj.id == this.language ).regional;
    })
  }

  setLanguage() {
    if (!this.selectedLang){ return; }
    this.i18nService.language = this.selectedLang.id;
  }

  selectLanguage(language: any) {
    this.selectedLang = language;
    if (!this.selectedLang){ return; }
    this.i18nService.language = this.selectedLang.id;
    this.currentSelectedValue = this.languages.find((langObj:any) => langObj.id == this.selectedLang.id ).regional;
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): any {
    return this.i18nService.supportedLanguages;
  }
}
